import React from 'react';
import { Lang } from 'shared/constants';
import { OwnerSelector } from '../../ownerSelector/owner-selector';
import { Popup } from '../../common';
import { Button, Loader } from '../../core';
import styles from './owner-delete.module.scss';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const OWNER_SCHEMA = Yup.object().shape({
  ownerId: Yup.string().required('Required!').nullable(false),
});

const OwnerDeleteComponent = React.memo(function OwnerDeleteComponent({
  lang,
  entity,
  deleteOwner,
  onFinish,
}) {
  const [isLoading, setLoadingState] = React.useState(false);

  const deleteOwnerAction = React.useCallback(
    async ({ ownerId }) => {
      setLoadingState(true);

      await deleteOwner({ id: entity.id, ownerId });
      // TODO: analytics

      onFinish();
      setLoadingState(false);
    },
    [deleteOwner, entity.id, onFinish],
  );

  const dismiss = React.useCallback(() => {
    // TODO: analytics

    onFinish();
  }, [onFinish]);

  const { handleSubmit, setFieldValue, values, errors } = useFormik({
    validationSchema: OWNER_SCHEMA,
    initialValues: {
      ownerId: null,
    },
    onSubmit: deleteOwnerAction,
  });

  if (!entity) return null;

  return (
    <Popup title={lang.TITLE} isOpen={true}>
      <form onSubmit={handleSubmit}>
        <p className={styles.content}>{lang.TEXT.replace('{email}', entity?.email)}</p>

        <OwnerSelector
          value={values?.ownerId}
          error={errors.ownerId}
          placeholder={lang.OWNER_PLACEHOLDER}
          name="ownerId"
          onChange={setFieldValue}
        />

        {!isLoading && (
          <div className={styles.buttons}>
            <Button
              className={styles.button}
              size="medium"
              type="submit"
              buttonStyle="danger"
              disabled={!values?.ownerId}
            >
              {lang.CONFIRM}
            </Button>
            <Button className={styles.button} onClick={dismiss} size="medium">
              {lang.DISMISS}
            </Button>
          </div>
        )}
        {isLoading && <Loader />}
      </form>
    </Popup>
  );
});

OwnerDeleteComponent.defaultProps = {
  lang: Lang.DELETE_OWNER_CONFIRMATION,
  entity: null,
  deleteOwner: () => {},
  onFinish: () => {},
};

export { OwnerDeleteComponent };
